import { ThemeOverride } from "@chakra-ui/react";

export const config: ThemeOverride["config"] = {
  initialColorMode: "dark",
  useSystemColorMode: false,
};
